module.exports = __webpack_public_path__ + "img/1.4b8779a8.svg";